/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { useHistory } from 'react-router-dom';
import { Badge, Button } from 'reactstrap';
import { generateUrl } from '../../util';
import { ROUTES } from '../../../constants/routes';

export const CarbonCalculatorsCallToAction = (props: { size: 'sm' | 'lg' }) => {
  const { size = 'sm' } = props;

  const history = useHistory();

  const handleGoToCarbonCalculator = () => {
    history.push(
      generateUrl(ROUTES.EMISSIONS_CALCULATORS)
    );
  };

  if (size === 'sm') {
    return (
      <div>
        <Button color='transparent' size='sm' outline className='btn-pill' onClick={() => handleGoToCarbonCalculator()}>
          <Badge color='success' pill className='outline mr-2 px-3 py-0 text-sm fw-normal'>New</Badge>
          Compare emissions calculator companies
          <i className='fal fa-arrow-right-long ml-2' />
        </Button>
      </div>
    );
  }

  return (
    <div className='p-6 background-ThemeBgLight text-center'>
      <div className='h2 fw-normal mt-3'>
        Need help choosing an Emissions Calculator?
      </div>
      <div className='h4 mt-3 text-ThemeTextMedium'>
        Our guide will help you discover what to look for, compare calculators, and choose the right one to help your business.
      </div>
      <Button color='primary' size='lg' outline className='mt-4' onClick={() => handleGoToCarbonCalculator()}>
        Learn more
      </Button>
    </div>
  );
}

